import './styles.scss';

import AutomationTripsTableHeader from '@/features/Automation/pages/AutomationTrips/components/AutomationTripsTable/AutomationTripsTableHeader';
import AutomationTripsTableRow from '@/features/Automation/pages/AutomationTrips/components/AutomationTripsTable/AutomationTripsTableRow';
import { ReactElement } from 'react';
import Table from '@/common/Table';
import { useAutomationTrips } from '@/features/Automation/pages/AutomationTrips';

const AutomationTripsTable = (): ReactElement => {
  const [{ trips }] = useAutomationTrips(({ state }) => [
    {
      trips: state.trips,
    },
  ]);

  return (
    <>
      <Table className="AutomationTripsTable" header={<AutomationTripsTableHeader />}>
        {trips.map((trip) => (
          <AutomationTripsTableRow {...trip} id={trip.id || trip.tripId} key={trip.tripId} />
        ))}
      </Table>
    </>
  );
};

export default AutomationTripsTable;
